import store from './store';
import { logout } from './sessionActions';

function getSessionFromStorage() {
    const browserStorage = { ...window.localStorage, ...window.sessionStorage };
    return browserStorage.session ? JSON.parse(browserStorage.session) : {};
}

let _headers = getSessionFromStorage().token
    ? {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getSessionFromStorage().token
      }
    : {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      };

export function headers() {
    return _headers;
}

export function parseJSON(response) {
    //onProcessResponse(response);

    if (response.ok) {
        return response.json();
    }

    return response.json().then(payload => {
        //let theState = store.getState();
        response.bodyContent = payload;
        onError(response);
        return Promise.reject(response);
    });
}

function onProcessResponse(response) {}

export function onError(response) {
    const {
        status,
        bodyContent: { Message },
        url
    } = response;
    if (status === 401) {
        if (Message === 'The user record could not be found.') store.dispatch(logout(store.getState().session));
        else if (Message === 'Authorization has been denied for this request.') {
            if (url.endsWith('/api/Helper/EmptyList')) store.dispatch(logout(store.getState().session));
            else fetch('/api/Helper/EmptyList', { headers: headers(), method: 'GET' }).then(parseJSON);
        }
    }
}

export function updateHeaders(newHeaders) {
    _headers = { ..._headers, ...newHeaders };
    Object.keys(_headers).forEach(key => {
        if (undefined === _headers[key]) {
            delete _headers[key];
        }
    });
}
